import React from 'react';
import IIconSvg from './IIconSvg';
import Svg from '../Svg';

const Edit: React.FC<IIconSvg> = ({ fill = 'none', stroke = '#0B1215', bgColor, size }) => (
  <Svg fill={fill} bgColor={bgColor} size={size} path="" viewBox="0 0 16 16">
    <path
      d="M11.3906 1.94291C11.5657 1.76781 11.7736 1.62892 12.0024 1.53416C12.2311 1.4394 12.4763 1.39063 12.724 1.39062C12.9716 1.39062 13.2168 1.4394 13.4456 1.53416C13.6743 1.62892 13.8822 1.76781 14.0573 1.94291C14.2324 2.11801 14.3713 2.32587 14.466 2.55465C14.5608 2.78342 14.6096 3.02862 14.6096 3.27624C14.6096 3.52387 14.5608 3.76906 14.466 3.99784C14.3713 4.22661 14.2324 4.43448 14.0573 4.60958L5.05729 13.6096L1.39062 14.6096L2.39063 10.9429L11.3906 1.94291Z"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default Edit;
